
import React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';
import { Lock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

interface PollHeaderProps {
  question: string;
  isClosed: boolean;
  totalVotes: number;
  createdAt: string;
}

const PollHeader: React.FC<PollHeaderProps> = ({
  question,
  isClosed,
  totalVotes,
  createdAt
}) => {
  return (
    <CardHeader>
      <CardTitle className="text-lg flex items-start justify-between group">
        <div>{question}</div>
        {isClosed && (
          <Lock className="h-4 w-4 text-gray-400 ml-2 mt-1 flex-shrink-0" />
        )}
      </CardTitle>
      <div className="text-sm text-gray-500 flex items-center justify-between mt-1">
        <div>
          {totalVotes} {totalVotes === 1 ? 'vote' : 'votes'}
        </div>
        <div>
          {formatDistanceToNow(new Date(createdAt), { addSuffix: true })}
        </div>
      </div>
    </CardHeader>
  );
};

export default PollHeader;
